module.exports = __webpack_public_path__ + "media/images/metronic/social/amazon-b56ffd6e799b546f02c285735ab82f6e.png";